<template>
  <v-container fluid>

    <h2 class="mb-4 font-weight-bold">
      Valorización – Requerimientos Adjudicados
    </h2>

    <v-row
      v-if="esAdmin"
      class="mb-4"
    >

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.proveedor"
          :items="listaProveedores"
          label="Proveedor"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.estado"
          :items="listarEstados"
          label="Estado"
          clearable
          dense
          outlined
        />
      </v-col>

    </v-row>

    <v-row>
      <v-col
        v-for="(item, index) in postulacionesAdjudicadas"
        :key="`${item.idrequerimiento}-${index}`"
        cols="12"
      >
        <v-card class="pa-4 elevation-2">

          <!-- HEADER -->
          <div class="d-flex justify-space-between align-center mb-3">
            <div>
              <div class="req-title">
                <strong>{{ item.denominacion.slice(0, 3) }}</strong>
                <span class="grey--text"> - {{ item.empresa_contacto }}</span>
                <v-chip x-small class="ml-1">
                  {{ item.nombre_categoria }}
                </v-chip>
              </div>
              <div class="req-subtitle">
                <span class="grey--text">{{ detallesTextoServicio(item.detalles) }} ({{ detallesTexto(item.detalles) }})</span>
                <v-icon small class="ml-2">mdi-calendar</v-icon>
                {{ formatearFecha(item.fecha_inicio) }}
              </div>
            </div>

            <!-- <v-chip
              small
              :color="cotizacionAprobada(item) ? 'green' : 'orange'"
              dark
            >
              {{ cotizacionAprobada(item) ? 'APROBADO' : 'EN PROCESO' }}
            </v-chip> -->
          </div>

          <v-divider class="mb-3"></v-divider>

          <!-- HISTORIAL -->
          <div v-if="item.cotizaciones && item.cotizaciones.length">

            <div
              v-for="c in ordenarCotizaciones(item.cotizaciones)"
              :key="c.id_cotizacion"
              class="cotizacion-card mb-2"
            >
              <div class="d-flex justify-space-between align-center">

                <div>
                  <div class="font-weight-bold text-h6">
                    {{ c.moneda === 'USD' ? '$' : 'S/' }} {{ c.monto }}
                  </div>

                  <div class="grey--text text-caption">
                    Enviada: {{ formatFecha(c.fecha_envio) }}
                  </div>

                  <div
                    v-if="c.fecha_respuesta"
                    class="green--text text-caption"
                  >
                    Aprobada o Respondida: {{ formatFecha(c.fecha_respuesta) }}
                  </div>

                  <div
                    v-if="c.detalle_cotizacion"
                    class="detalles mt-1"
                  >
                    <v-icon small class="mr-1">mdi-file-document-outline</v-icon> Detalles: {{ c.detalle_cotizacion }}
                  </div>

                  <div
                    v-if="c.observacion"
                    class="observacion mt-1"
                  >
                    💬 Descripción: {{ c.observacion }}
                  </div>
                </div>

                <v-chip
                  small
                  :color="getColorEstado(c.estado)"
                  dark
                >
                  {{ c.estado }}
                </v-chip>

                <v-btn
                  v-if="c.estado === 'PENDIENTE' || c.estado === 'OBSERVADO'"
                  small
                  color="primary"
                  text
                  @click="editarCotizacion(c, item)"
                >
                  <v-icon small left>mdi-pencil</v-icon>
                  Editar
                </v-btn>

                <!-- SOLO ÚLTIMA Y PENDIENTE -->
                <!-- <div v-if="esUltima(cot, empresa) && cot.estado === 'PENDIENTE'"> -->
                <!-- <div class="text-center">
                  
                  <div v-if="esTransporteLiviano(item) && c.estado === 'PENDIENTE'">

                    <v-btn
                      small
                      class="btn-aprobar mr-2"
                      @click="aprobar(c)"
                    >
                      <v-icon small left>mdi-check</v-icon>
                      Aprobar
                    </v-btn>

                    <v-btn
                      small
                      class="btn-observar"
                      @click="abrirObservacion(c)"
                    >
                      <v-icon small left>mdi-alert</v-icon>
                      Observar
                    </v-btn>

                  </div>

                  <span v-else>-</span>

                </div> -->

              </div>
            </div>

          </div>

          <div v-else class="text-center grey--text py-4">
            Sin valorizaciones
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- ACCIONES -->
          <div class="d-flex justify-end">

            <v-btn
              color="primary"
              small
              @click="abrirModal(item)"
              v-if="!esTransporteLiviano(item)"
            >
            <!-- v-if="puedeSubir(item)&&
                    !esTransporteLiviano(item)" -->
              <v-icon small left>mdi-upload</v-icon>
              Subir valorización
            </v-btn>

            <!-- <v-chip
              v-if="cotizacionAprobada(item)"
              color="green"
              small
              dark
            >
              ✅ Aprobado
            </v-chip> -->

          </div>

        </v-card>
      </v-col>
    </v-row>

    <!-- MODAL -->
    <v-dialog v-model="showModal" max-width="500">
      <v-card>
        <v-card-title>
          {{ modoEdicion ? 'Editar valorización' : 'Nueva valorización' }}
        </v-card-title>

        <v-card-text>
          <v-select
            label="Moneda"
            :items="monedas"
            item-title="text"
            item-value="value"
            v-model="cotizacion.moneda"
            outlined dense
          />

          <v-text-field
            label="Monto"
            type="number"
            v-model.number="cotizacion.monto"
            :prefix="cotizacion.moneda === 'PEN' ? 'S/ ' : '$ '"
            outlined dense
          />

          <v-textarea
            label="Descripción"
            v-model="cotizacion.detalle_cotizacion"
            outlined dense
          />

          <v-text-field
            label="Fecha de respuesta"
            type="date"
            v-model="cotizacion.fecha_respuesta"
            outlined
            dense
          />

        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="showModal = false">
            Cancelar
          </v-btn>

          <v-btn color="primary" @click="guardarCotizacion">
            {{ modoEdicion ? 'Guardar cambios' : 'Enviar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL OBSERVAR -->
    <v-dialog v-model="dialogObs" max-width="500">
      <v-card>
        <v-card-title>
          Observar valorización
        </v-card-title>

        <v-card-text>
          <v-textarea
            label="Ingrese observación"
            v-model="observacion"
            outlined dense
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialogObs = false">
            Cancelar
          </v-btn>

          <v-btn color="red" dark @click="confirmarObservacion">
            Observar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>

  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CotizacionRequerimientos',

  data () {
    return {
      postulaciones: [],
      showModal: false,
      dialogObs: false,
      observacion: '',
      postulacionActual: null,

      cotizacion: {
        monto: null,
        detalle_cotizacion: '',
        moneda: 'PEN',
        fecha_respuesta: ''
      },

      monedas: [
        { text: 'Soles (PEN)', value: 'PEN' },
        { text: 'Dólares (USD)', value: 'USD' }
      ],

      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },

      empresaid: null,
      idusuario: null,
      filtros: {
        proveedor: null,
        estado: null
      },
      modoEdicion: false,
      cotizacionSeleccionada: null,
    }
  },

  computed: {
    // postulacionesAdjudicadas () {
    //   var self = this
    //   return self.postulaciones.filter(function (p) {
    //     return p.estado === 'ADJUDICADO'
    //   })
    // }
    listaProveedores () {
      return [
        ...new Set(
          this.postulacionesBase.map(
            p => p.empresa_contacto
          )
        )
      ]
    },

    listarEstados () {
      return [
        'APROBADO',
        'OBSERVADO',
        'PENDIENTE',
        'SIN VALORIZACION'
      ]
    },

    postulacionesBase () {
      return this.postulaciones.filter(
        p => p.estado === 'ADJUDICADO'
      )
    },

    postulacionesAdjudicadas () {

      return this.postulacionesBase.filter(item => {

        // proveedor
        if (
          this.filtros.proveedor &&
          item.empresa_contacto !== this.filtros.proveedor
        ) {
          return false
        }

        // sin filtro estado
        if (!this.filtros.estado) {
          return true
        }

        // SIN VALORIZACION
        if (
          this.filtros.estado === 'SIN VALORIZACION'
        ) {
          return !item.cotizaciones ||
                 !item.cotizaciones.length
        }

        // no tiene valorizaciones
        if (!item.cotizaciones?.length) {
          return false
        }

        // buscar estado en cotizaciones
        return item.cotizaciones.some(
          c => c.estado === this.filtros.estado
        )
      })
    }
  },

  created () {
    this.idusuario = localStorage.getItem('idusuario')
    this.empresaid = Number(localStorage.getItem('empresa'))
    this.rol = localStorage.getItem('rol')
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
    this.listarPostulaciones()
  },

  methods: {

    async listarPostulaciones () {
      try {
        var res = await axios.get(
          'api/CotizacionRequerimientos/ListarPorEmpresa/' + this.idusuario
        )

        this.postulaciones = Array.isArray(res.data) ? res.data : []

      } catch (e) {
        this.postulaciones = []
      }
    },

    formatFecha (fecha) {
      if (!fecha) return ''
      return fecha.split('T')[0].split('-').reverse().join('/')
    },

    ordenarCotizaciones (cotizaciones) {
      if (!cotizaciones) return []
      return cotizaciones.slice().sort(function (a, b) {
        return b.version - a.version
      })
    },

    getColorEstado (estado) {
      if (estado === 'APROBADO') return 'green'
      if (estado === 'OBSERVADO') return 'red'
      return 'orange'
    },

    cotizacionAprobada (item) {
      if (!item.cotizaciones) return false

      return item.cotizaciones.some(function (c) {
        return c.estado === 'APROBADO'
      })
    },

    puedeSubir (item) {
      if (!item.cotizaciones || !item.cotizaciones.length) return true

      var ordenadas = this.ordenarCotizaciones(item.cotizaciones)
      var ultima = ordenadas[0]

      return ultima.estado === 'OBSERVADO'
    },

    abrirModal (item) {
      this.postulacionActual = item
      this.cotizacionSeleccionada = null
      this.modoEdicion = false
      this.cotizacion = {
        monto: null,
        detalle_cotizacion: '',
        moneda: 'PEN',
        fecha_respuesta: ''
      }
      this.showModal = true
    },

    async guardarCotizacion () {
      try {
        var formData = new FormData()

        formData.append('monto', this.cotizacion.monto)
        formData.append('moneda', this.cotizacion.moneda)
        formData.append('detalle_cotizacion', this.cotizacion.detalle_cotizacion)
        formData.append('idrequerimiento', this.postulacionActual.idrequerimiento)
        formData.append('id_empresa', this.empresaid)
        formData.append('fecha_respuesta', this.cotizacion.fecha_respuesta)

        if (this.modoEdicion) {
          // ID de la cotización que se está editando
          formData.append(
            'id_cotizacion',
            this.cotizacionSeleccionada.id_cotizacion
          )

          await axios.put(
            'api/CotizacionRequerimientos/Editar',
            formData
          )

          this.snackbar = {
            show: true,
            text: 'Valorización actualizada correctamente',
            color: 'success'
          }
        } else {
          await axios.post(
            'api/CotizacionRequerimientos/Crear',
            formData
          )
          this.snackbar = {
            show: true,
            text: 'Valorización enviada correctamente',
            color: 'success'
          }
        }
        this.showModal = false

        this.modoEdicion = false
        this.cotizacionSeleccionada = null

        this.postulaciones = []
        await this.listarPostulaciones()

      } catch (error) {
        console.error(error)
        this.snackbar = {
          show: true,
          text: this.modoEdicion
            ? 'Error al actualizar valorización'
            : 'Error al enviar valorización',
          color: 'error'
        }
      }
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    esTransporteLiviano(item){
      return (
        item.nombre_categoria &&
        item.nombre_categoria.toUpperCase() ===
        'TRANSPORTE LIVIANO Y DE PERSONAL'
      )
    },
    async aprobar (cot) {
      try {
        await axios.put('api/CotizacionRequerimientos/Aprobar', {
          idCotizacion: cot.id_cotizacion
        })

        this.snackbar = {
          show: true,
          text: 'Valorización aprobada',
          color: 'success'
        }

        this.listar()

      }
      catch (e){
        this.snackbar = {
          show: true,
          text: 'Error al aprobar',
          color: 'error'
        }
      }
    },

    abrirObservacion (cot) {
      this.cotizacionSeleccionada = cot
      this.observacion = ''
      this.dialogObs = true
    },
    async confirmarObservacion () {
      try {
        await axios.put('api/CotizacionRequerimientos/Observar', {
          idCotizacion: this.cotizacionSeleccionada.id_cotizacion,
          observacion: this.observacion
        })

        this.snackbar = {
          show: true,
          text: 'Valorización observada',
          color: 'success'
        }

        this.dialogObs = false
        this.listar()

      } catch (e){
        this.snackbar = {
          show: true,
          text: 'Error al observar',
          color: 'error'
        }
      }
    },
    editarCotizacion (c, item) {
      this.postulacionActual = item
      this.cotizacionSeleccionada = c
      this.modoEdicion = true

      this.cotizacion = {
        monto: c.monto,
        detalle_cotizacion: c.detalle_cotizacion || '',
        moneda: c.moneda || 'PEN',
        fecha_respuesta: c.fecha_respuesta
          ? c.fecha_respuesta.split('T')[0]
          : ''
      }

      this.showModal = true
    },
  }
}
</script>

<style scoped>
.cotizacion-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  transition: 0.2s;
}

.cotizacion-card:hover {
  background: #f9fafb;
}

.observacion {
  color: #b91c1c;
  font-size: 12px;
}

.detalles {
  font-size: 13px;
  color: #1f2937;
  background: #f3f4f6;
  padding: 6px 10px;
  border-radius: 6px;
}

.btn-aprobar {
  background-color: #16a34a !important;
  color: white !important;
}

.btn-observar {
  background-color: #dc2626 !important;
  color: white !important;
}

.req-title {
  font-size: 18px;
  font-weight: 700;
}

.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}
</style>